export function sendFile({file, url, headers = [], method = 'POST'}){
    return new Promise((resolve, reject) => {
        const oReq = new XMLHttpRequest();
        oReq.open(method, url, true);
        oReq.setRequestHeader("Content-Type", file.type);
        headers.forEach(header => {
            oReq.setRequestHeader(header.key, header.value)
        });
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.addEventListener("load", e => {
            const buffer = e.target.result;
            oReq.send(buffer);
        });
        oReq.addEventListener('load', function (oEvent) {
            const resultStatus = oEvent.target.status;
            if(resultStatus !== 200){
               return reject({ response: oEvent.target.response, status: resultStatus});
            }
            return resolve(oEvent)
        });
        oReq.addEventListener('error', function (oEvent) {
            reject(oEvent)
        });
    });
}


// WEBPACK FOOTER //
// ./src/services/fileSender.js